import { render, staticRenderFns } from "./ModalConsignmentSetWeightDirty.vue?vue&type=template&id=80499238&"
import script from "./ModalConsignmentSetWeightDirty.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentSetWeightDirty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports